import { required, maxLength, numeric, } from 'vuelidate/lib/validators'

const regexCodigo = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return (
    /^\d+(\.\d+)*$/g.test(value)
  )
}

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    codigo: { required, regexCodigo },
    qtCallsDaily: { required, numeric, maxLength: maxLength(15) },
    qtCallsWeekly: { required, numeric, maxLength: maxLength(15) },
    qtCallsMonthly: { required, numeric, maxLength: maxLength(15) },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Campo obrigatório.')
    !this.$v.form.description.maxLength && errors.push('Não pode conter mais de 30 caracteres.')
    return errors
  },

  codigoErrors() {
    const errors = []
    if (!this.$v.form.codigo.$dirty) return errors
    !this.$v.form.codigo.required && errors.push('Campo obrigatório.')
    !this.$v.form.codigo.regexCodigo && errors.push('Código deve ter apenas números e pontos.')
    return errors
  },
  qtCallsDailyErrors() {
    const errors = []
    if (!this.$v.form.qtCallsDaily.$dirty) return errors
    !this.$v.form.qtCallsDaily.required && errors.push('Campo obrigatório.')
    !this.$v.form.qtCallsDaily.numeric && errors.push('Somente números.')
    return errors
  },
  qtCallsWeeklyErrors() {
    const errors = []
    if (!this.$v.form.qtCallsWeekly.$dirty) return errors
    !this.$v.form.qtCallsWeekly.required && errors.push('Campo obrigatório.')
    !this.$v.form.qtCallsWeekly.numeric && errors.push('Somente números.')
    return errors
  },
  qtCallsMonthlyErrors() {
    const errors = []
    if (!this.$v.form.qtCallsMonthly.$dirty) return errors
    !this.$v.form.qtCallsMonthly.required && errors.push('Campo obrigatório.')
    !this.$v.form.qtCallsMonthly.numeric && errors.push('Somente números.')
    return errors
  },
}
